import React from 'react'
import { Link } from 'gatsby'
import * as styles from '../css/footer.module.scss'
import GoogleAnalytics from '../images/google_analytics.png'
import DynamicYield from '../images/partner_dynamicyield_stacked.png'
import Tealium from '../images/partner_tealium.png'
import AWS from '../images/aws-consulting-partner.png'
import StiboDX from '../images/partner_stibodx_stacked.png'


const Footer = ({siteTitle}) => (
    <footer>
        <div className={styles.footer_top}>
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-md-8">
                        <div className={styles.analytics_image}>
                            <img className={styles.analytics_image}
                                 src={AWS}
                                 alt="Logo / Zertifikat - AWS"
                            />
                            <img className={styles.analytics_image}
                                 src={GoogleAnalytics}
                                 alt="Logo / Zertifikat - Google Analytics"
                            />
                            <img className={styles.analytics_image}
                                 src={DynamicYield}
                                 alt="Logo / Zertifikat - Dynamic Yield"
                            />
                            <img className={styles.analytics_image}
                                 src={Tealium}
                                 alt="Logo / Zertifikat - Tealium"
                            />
                            <img className={styles.analytics_image}
                                 src={StiboDX}
                                 alt="Logo / Zertifikat - Stibo DX"
                            />
                        </div>

                        <p>Valiton zeigt zertifizierte Kompetenz im Bereich Cloud Consulting und Webanalytics.</p>
                    </div>

                    <div className="col-xs-12 col-md-4">
                        <h3>Kontakt</h3>

                        <p>Valiton GmbH<br/>
                            Arabellastraße 23<br/>
                            D-81925 München
                        </p>

                        <p>
                            Roswitha Hartmann<br/>
                            Tel. 089 9250 1226
                        </p>

                        <p>
                            <a href="mailto:kontakt@valiton.com"
                               title="Valiton E-Mail Kontakt"
                               className={styles.mailto}
                            >
                                kontakt@valiton.com
                            </a>
                        </p>
                    </div>
                </div>
            </div>
        </div>

        <div className={styles.footer_bottom}>
            <div className="container">
                <div className="row">
                    <div className="col-xs-12 col-md-8 order-2 order-md-1">
                        <nav>
                            <ul>
                                <li>
                                    <Link to="/nutzungsbestimmungen"
                                          title="Zu den Nutzungsbestimmungen"
                                          className={styles.footer_link}
                                    >
                                        Nutzungsbestimmungen
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/datenschutz"
                                          title="Zu den Datenschutzbestimmungen"
                                          className={styles.footer_link}
                                    >
                                        Datenschutz
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/impressum"
                                          title="Zum Impressum"
                                          className={styles.footer_link}
                                    >
                                        Impressum
                                    </Link>
                                </li>

                                <li>
                                    <Link to="/barrierefreiheit"
                                          title="Zu der Information zur Barrierefreiheit"
                                          className={styles.footer_link}
                                    >
                                        Information zur Barrierefreiheit
                                    </Link>
                                </li>
                            </ul>
                        </nav>
                    </div>

                    <div className="col-xs-12 col-md-4 order-1 order-md-2">
                        <a href="https://www.xing.com/companies/valitongmbh"
                           target="_blank"
                           rel="noopener noreferrer"
                           title="Zu Xing"
                           className={styles.social__link__xing}
                        >
                            Xing
                        </a>
                        <a href="https://www.kununu.com/de/valiton1"
                           target="_blank"
                           rel="noopener noreferrer"
                           title="Zu Kununu"
                           className={styles.social__link__kununu}
                        >
                            Kununu
                        </a>
                        <a href="https://www.linkedin.com/company/valiton"
                           target="_blank"
                           rel="noopener noreferrer"
                           title="Zu LinkedIn"
                           className={styles.social__link__linkedin}>
                            LinkedIn
                        </a>
                        <a href="https://github.com/valiton"
                           target="_blank"
                           rel="noopener noreferrer"
                           title="Zu Github"
                           className={styles.social__link__github}
                        >
                            Github
                        </a>
                        <a href="https://partners.amazonaws.com/partners/0010L00001u6RGaQAM/Valiton%20GmbH"
                           target="_blank"
                           rel="noopener noreferrer"
                           title="Zur AWS Partner Page"
                           className={styles.social__link__aws}
                        >
                            AWS Partner Page
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </footer>
)

export default Footer
